<template>
  <div>
    <!-- 组套详细 -->
    <el-dialog :title="$t('message.kitAssemblyDetails')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="688px" center>

      <div class="table">
        <ol>
          <!-- 番号 -->
          <li>{{ $t('message.mash') }}

          </li>
          <!-- 图片 -->
          <li>{{ $t('message.pic') }}</li>
          <!-- sku -->
          <li style="flex:2">SKU</li>
          <!-- 数量 -->
          <!-- <li>{{ $t('message.quantity') }}</li> -->
        </ol>
        <ul v-for="(item, index) in tableData" :key="index">
          <!-- 番号 -->
          <li>{{ item.sorting }}-
            <span v-if="index == 0" style="color: #B4272D;">主</span>
            <span v-else style="color: #85ce61;">同捆</span>
          </li>
          <!-- 图片 -->
          <li>
            <el-popover placement="right" width="300" trigger="hover">
              <img :src="item.pic" alt="" style="width: 300px; height: 300px" />
              <a :href="item.link" slot="reference" target="_blank">
                <el-image :src="item.pic" style="width: 60px; height: 60px; border-radius: 4px">
                  <div slot="placeholder" class="image-slot">
                    加载中<span class="dot">...</span>
                  </div>
                </el-image>
              </a>
            </el-popover>
          </li>
          <!-- sku -->
          <li style="flex:2">
            <el-tooltip placement="bottom" style="height:100px">
              <div slot="content">
                <div class="row" v-for="(itemDetail, itemIndex) in item.detail_y" :key="itemIndex"
                  style="margin-bottom: 5px">
                  {{ itemDetail.key }}：{{ itemDetail.value }}
                </div>
              </div>
              <div>
                <div class="row" v-for="(itemDetail, itemIndex) in item.detail_y" :key="itemIndex"
                  @click="copy(itemDetail.value)">
                  {{ itemDetail.key }}：{{ itemDetail.value }}
                </div>
              </div>
            </el-tooltip>
          </li>
          <!-- 数量 -->
          <!-- <li>{{ item.packing_quantity }} 点/套</li> -->
        </ul>
      </div>
    </el-dialog>
  </div>
</template>
<script>

export default {
  props: {
    order_detail: { type: Array }
  },
  data() {
    return {
      tableData: [],
      dialogVisible: false,
    };
  },

  methods: {
    getDataList(arr) {
      this.tableData = []
      arr.forEach(id => {
        this.order_detail.forEach(item => {
          if (id == item.id || id == item.order_detail_id) {
            this.tableData.push(item)
          }
        })
      })
      this.dialogVisible = true
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px 20px;
  display: flex;


}
</style>